export default __webpack_public_path__ + "static/media/sticker-k.7eae83ae.png";